// language=GraphQL
export const ALL_PARTNER_TENANTS_QUERY = `query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
  partnerTenants: partnerTenants {
    id
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        previewTravelInterestTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        datatransMerchantId
        datatransMerchantPw
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
        co2CompensationInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    filterCrossLinking
  }
}`

// language=GraphQL
export const SINGLE_PARTNER_TENANT_QUERY = `query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
  partnerTenant: partnerTenant(id: $id) {
    id
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        previewTravelInterestTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        datatransMerchantId
        datatransMerchantPw
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
        co2CompensationInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    filterCrossLinking
  }
}`

// language=GraphQL
export const CREATE_PARTNER_TENANT_MUTATION = `
  mutation Mutation($input: CreatePartnerTenantInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
    partnerTenant: createPartnerTenant(input: $input) {
      id
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      filterCrossLinking
    }
  }`

// language=GraphQL
export const UPDATE_PARTNER_TENANT_MUTATION = `
  mutation Mutation($input: UpdatePartnerTenantInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
    partnerTenant: updatePartnerTenant(input: $input) {
      id
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      filterCrossLinking
    }
  }`

// language=GraphQL
export const DELETE_PARTNER_TENANT_MUTATION = `
  mutation Mutation($input: DeletePartnerTenantInput) {
    deletePartnerTenant(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PARTNER_TENANT_MUTATION = `
  mutation Mutation($input: DeletePartnerTenantInput) {
    forceDeletePartnerTenant(input: $input) {
      success
    }
  }`
// language=GraphQL
export const PARTNER_TENANTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: partnerTenantDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
